import React from 'react';
import { componentService } from 'js/services/component.service';

export const LoggedOut = React.lazy(() => import(/* webpackChunkName: "logged-out" */ './LoggedOut'));

componentService.registerWebContentComponents({ LoggedOut });
